exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".restaurants-component .restaurants-banner{padding-top:24px;padding-bottom:12px}.restaurants-component .restaurants-banner__text-holder{position:relative;height:256px;padding:24px;color:#fff}.restaurants-component .restaurants-banner__text{position:absolute;bottom:12px;left:24px;right:24px}.restaurants-component .restaurants-banner__image-holder{position:relative;height:256px;border-radius:8px 8px 0 0;background-repeat:no-repeat;background-position:50%;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover}.restaurants-component .restaurants-banner__overlay{border-radius:8px 8px 0 0;position:absolute;top:0;bottom:0;right:0;left:0;background:rgba(0,0,0,.55)}@media (min-width:768px){.restaurants-component .restaurants-banner__overlay{background:linear-gradient(90deg,rgba(0,0,0,.7),rgba(0,0,0,.5) 65%,rgba(0,0,0,.1))}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/restaurants.scss
// module id = 1027
// module chunks = 0